import { useState } from 'react';

import { Outlet, useLocation } from 'react-router-dom';

import { Layout, theme } from 'antd';

import { Header } from '@/shared/ui/layout/Header';
import { Sidebar } from '@/shared/ui/layout/Sidebar';

import styles from './MainLayout.module.css';

const { Content } = Layout;

type MainLayoutProps = {
  searchBar?: React.ReactNode;
};

const NO_PADDING_ROUTES = [
  '/search',
  '/experiments',
  '/workbench',
  '/service',
  '/table',
  '/databaseSchema',
  '/database',
  '/service',
  '/dag-detail',
];

export const MainLayout: React.FC<MainLayoutProps> = ({ searchBar }) => {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  const location = useLocation();
  const {
    token: { colorBgContainer },
  } = theme.useToken();

  const handleToggleSidebar = () => {
    setSidebarCollapsed(!sidebarCollapsed);
  };

  const shouldRemovePadding = NO_PADDING_ROUTES.some((route) => {
    return location.pathname === route || location.pathname.startsWith(route + '/');
  });

  return (
    <Layout className={styles.layout}>
      <Header
        colorBgContainer={colorBgContainer}
        collapsed={sidebarCollapsed}
        onToggleSidebar={handleToggleSidebar}
        searchBar={searchBar}
      />
      <Layout hasSider className={styles.bodyLayout}>
        <Sidebar colorBgContainer={colorBgContainer} collapsed={sidebarCollapsed} />
        <Layout className={styles.contentLayout}>
          <Content className={shouldRemovePadding ? styles.contentNoPadding : styles.content}>
            <Outlet />
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};
